require('script-loader!./bower_components/TweenJS/lib/tweenjs-0.6.2.combined.js');
require('script-loader!./bower_components/easeljs/lib/easeljs-0.8.2.combined.js');

window.bowser = require('bowser');
require('script-loader!./bower_components/visibilityjs/lib/visibility.core.js');

require('./pvplib/Loader.js');
require('./pvplib/ImageLoader.js');
require('./pvplib/Cookie.js');
require('./pvplib/ContainerExt.js');
require('./pvplib/Vector2D.js');
require('./pvplib/Killable.js');
require('./pvplib/CreateJSPlayer.js');
require('./pvplib/ScaledContainer.js');
require('./pvplib/config.js');

require('script-loader!./hommageplayer/vagues/vagues.min.js');

require('script-loader!./hommageplayer/video_player_m.js');
require('./hommageplayer/Photo.js');
require('./hommageplayer/Video.js');
require('./hommageplayer/Introduction.js');
require('./hommageplayer/Conclusion.js');
require('./hommageplayer/Message.js');
require('./hommageplayer/Slideshow.js');

require('./hommageplayer/CenterBtn.js');
require('./hommageplayer/BottomBar.js');

require('./hommageplayer/PlayControls.js');
require('./hommageplayer/BtnsActions.js');
require('./hommageplayer/MusicPlayer.js');
require('./hommageplayer/VideoPlayer.js');
require('./hommageplayer/hommage.view.js');
